// Product page enhancements. The page works without this file:
// - the phone add bar is a plain submit button for the product form;
// - the refill picker's preset plan is already the Subscribe radio's value;
// - jump links are plain anchors.
(function () {
  if (window.nPdpBound) return;
  window.nPdpBound = true;

  // Refill picker: the select carries no name; it sets the Subscribe radio's plan.
  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-n-refill]');
    if (!select) return;
    const radio = document.getElementById(select.dataset.nRefill);
    if (!radio) return;
    radio.value = select.value;
    radio.dataset.sellingPlanId = select.value;
    radio.checked = true;
    radio.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Phone add bar: shows once the main Add to cart has scrolled above the viewport.
  const bar = document.querySelector('[data-n-sticky-atc]');
  if (bar && 'IntersectionObserver' in window) {
    const target = document.getElementById(bar.dataset.nStickyAtc);
    const root = document.documentElement;
    if (target) {
      const observer = new IntersectionObserver(
        ([entry]) => {
          const past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          bar.classList.toggle('is-visible', past);
          root.classList.toggle('n-sticky-atc-on', past);
        },
        { threshold: 0 }
      );
      observer.observe(target);
    }

    // Keep the bar's price in step with the chosen purchase option.
    const price = bar.querySelector('[data-n-sticky-price]');
    const sync = () => {
      const checked = document.querySelector('.product-purchase-options input[type="radio"]:checked');
      if (!checked || !price) return;
      const label = document.querySelector(`label[for="${checked.id}"]`);
      if (!label) return;
      const shown = Array.from(label.querySelectorAll('.product-purchase-options__price')).find(
        (node) => node.offsetParent !== null
      );
      if (shown) price.textContent = shown.textContent.trim();
    };
    document.addEventListener('change', (event) => {
      if (event.target.closest('.product-purchase-options')) sync();
    });
    window.addEventListener('load', sync);
  }

  // Questions: FAQ and Q&A as tabs. Without JS both lists show, one after the other.
  document.querySelectorAll('[data-n-tabs]').forEach((root) => {
    const list = root.querySelector('[data-n-tablist]');
    if (!list) return;
    const tabs = Array.from(list.querySelectorAll('[role="tab"]'));
    const select = (tab, focus) => {
      tabs.forEach((t) => {
        const on = t === tab;
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
        const panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (focus) tab.focus();
    };
    list.hidden = false;
    root.classList.add('is-tabbed');
    select(tabs[0]);
    list.addEventListener('click', (e) => {
      const tab = e.target.closest('[role="tab"]');
      if (tab) select(tab);
    });
    list.addEventListener('keydown', (e) => {
      const i = tabs.indexOf(document.activeElement);
      if (i < 0) return;
      let next = null;
      if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
      if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
      if (e.key === 'Home') next = tabs[0];
      if (e.key === 'End') next = tabs[tabs.length - 1];
      if (next) {
        e.preventDefault();
        select(next, true);
      }
    });
  });

  // Jump links: mark the section in view.
  const nav = document.querySelector('[data-n-jump]');
  if (nav && 'IntersectionObserver' in window) {
    const links = Array.from(nav.querySelectorAll('a[href^="#"]'));
    const targets = links.map((link) => document.getElementById(link.hash.slice(1))).filter(Boolean);
    const setCurrent = (id) => {
      links.forEach((link) => {
        if (link.hash === `#${id}`) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });
    };
    const seen = new Map();
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => seen.set(entry.target.id, entry.isIntersecting));
        const first = targets.find((t) => seen.get(t.id));
        if (first) setCurrent(first.id);
      },
      { rootMargin: '-30% 0px -60% 0px' }
    );
    targets.forEach((t) => observer.observe(t));
  }
})();
